import { Component } from 'react';
import styled from 'styled-components';

const FloatElement = styled.div<IProps>`
  position: fixed;
  display: flex;
  box-sizing: content-box;
  margin-bottom: 10px;
  bottom: ${props => (props.isOpen ? '20px' : '-100px')};
  transition: all 0.3s ease-in;
  z-index: 10;
  left: 0;
  right: 0;
  justify-content: center;
`;

const FloatContentElement = styled.div`
  display: flex;
  border: 1px solid rgba(0, 0, 0, 0.1);
  box-shadow: 0px 2px 7px 0px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  background-color: white;
  padding: 15px;

  && > * {
    flex: 1;
  }
`;

interface IProps {
  isOpen?: boolean;
}

export class Float extends Component<IProps> {
  public render() {
    return (
      <FloatElement isOpen={this.props.isOpen} data-testid="FloatElement">
        <FloatContentElement>{this.props.children}</FloatContentElement>
      </FloatElement>
    );
  }
}
